// [2026-03-22] 다중 테넌트 + 역할 기반 권한 지원
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TenantInfo {
  tenant_id: string;
  tenant_name: string;
  role: string;
}

interface User {
  id: string;
  email: string;
  name: string;
  is_superuser: boolean;
  tenant_id: string | null;
  tenants?: TenantInfo[];
}

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  activeTenant: TenantInfo | null;  // 현재 활성 테넌트
  setUser: (user: User | null) => void;
  setAuthenticated: (value: boolean) => void;
  setActiveTenant: (tenant: TenantInfo | null) => void;
  logout: () => void;
  isSuperuser: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      isAuthenticated: false,
      activeTenant: null,
      setUser: (user) => {
        // 로그인 시 첫 번째 테넌트를 활성으로 설정
        let activeTenant: TenantInfo | null = null;
        if (user && !user.is_superuser && user.tenants && user.tenants.length > 0) {
          activeTenant = user.tenants[0];
        }
        set({ user, isAuthenticated: !!user, activeTenant });
      },
      setAuthenticated: (value) => set({ isAuthenticated: value }),
      setActiveTenant: (tenant) => set({ activeTenant: tenant }),
      logout: () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        set({ user: null, isAuthenticated: false, activeTenant: null });
      },
      isSuperuser: () => get().user?.is_superuser === true,
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
        activeTenant: state.activeTenant,
      }),
    }
  )
);
